import React, { ComponentPropsWithoutRef, ReactNode, useRef } from 'react'
import * as S from './BasicTextArea.styled'

interface IBasicTextArea extends ComponentPropsWithoutRef<'textarea'> {
  children?: ReactNode
  tag?: string
  error?: string
  isPrimary?: boolean
  isErrorLine?: boolean
}
const BasicTextArea = ({ tag, children, error, isPrimary = false, isErrorLine = false, ...props }: IBasicTextArea) => {
  return (
    <S.InfoInput>
      {tag && (
        <div className="flex w-full gap-[20px] items-center justify-between mb-[10px]">
          <span>
            {isPrimary ? <span className="text-[#583EEE]">* </span> : null}
            {tag}
          </span>
          <span>{error && <p className="text-[#e91212] text-[12px]">{error}</p>}</span>
        </div>
      )}
      <S.Input isErrorLine={isErrorLine}>
        <textarea {...props} />

        {children && <S.Func>{children}</S.Func>}
      </S.Input>
    </S.InfoInput>
  )
}

export default BasicTextArea
